<template>
  <div class="Index">
    <div class="content">
      <img src="../assets/join.png" class="img-fluid" alt="Responsive image">
      <div class="content-detail">
        <h1 data-delighter>寻利他，求共赢</h1>
      </div>
    </div>
    <!-- content开始 -->
    <div class="container">
      <div class="row content-one-title">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <h1>产品优势</h1>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="card-deck">
            <div class="card card-kind">
              <img class="card-img-top card-img" src="../assets/join-01.png" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title title">“互联网+打印”新时代</h5>
                <p class="card-text"> 大数据云存储，PC端、手机端实时共享内容</p>
              </div>
            </div>
            <div class="card card-kind">
              <img class="card-img-top card-img" src="../assets/join-02.png" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title title">高效文印，节省人力成本</h5>
                <p class="card-text">自助打印系统，自动结算，主动叫修，省时省力更省心</p>
              </div>
            </div>
            <div class="card card-kind">
              <img class="card-img-top card-img" src="../assets/join-03.png" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title title">适用于多场景应用</h5>
                <p class="card-text">根据不同商业需求，配置适用于不同场所产品</p>
              </div>
            </div>
            <div class="card card-kind">
              <img class="card-img-top card-img" src="../assets/join-04.png" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title title">完备的售后运营服务</h5>
                <p class="card-text">7*24小时全天候运维在线，维护管理</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row content-one-title">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <h1>适用对象</h1>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="card-deck">

            <div class="card card-kind">
              <img class="card-img-top card-icon" src="../assets/join-05.png" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title title">具有一定资质的渠道商、打印厂商</h5>
              </div>
            </div>

            <div class="card card-kind">
              <img class="card-img-top card-icon" src="../assets/join-08.png" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title title">共享打印投放商</h5>
              </div>
            </div>

            <div class="card card-kind">
              <img class="card-img-top card-icon" src="../assets/join-06.png" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title title">具有自助打印需求的文印店</h5>
              </div>
            </div>


            <div class="card card-kind">
              <img class="card-img-top card-icon" src="../assets/join-07.png" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title title">具有打印管理需求的企业级客户</h5>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <img src="../assets/flow.png" class="img-fluid" alt="Responsive image">
    <img src="../assets/hot-line.png" class="img-fluid" alt="Responsive image">
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {};
  },
  created() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  position: relative;
}

.content-detail {
  position: absolute;
  top: 20%;
  left: 10%;

  h1 {
    font-size: 3.2rem;
    font-weight: 100 !important;
    line-height: 2rem;
    color: #fff;
  }
}

.card-img {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  transition: width 1s linear 2s;
  -webkit-transition: width 1s height 1s linear 2s;
}

.card-icon {
  width: auto;
  height: 150px;
  margin: 0 auto;
  transition: width 1s linear 2s;
  -webkit-transition: width 1s height 1s linear 2s;
}

.title {
  font-size: 16px !important;
  font-weight: bold;
}

// .icon {
// width: 90px;
// height: 90px;
// }

// .clear {
// margin-left: 0 !important;
// margin-right: 0 !important;
// }

// 多场景解决方案
.card-over {
  padding: 8rem 2rem !important;

  .line {
    width: 40px;
    height: 2px;
    margin: 30px auto;
    background-color: #fff;
  }

  p, button {
    opacity: 0;
  }
}

// 多场景解决方案鼠标移动效果
.clear:hover {
  position: relative;

  .card-over {
    padding: 2.25rem !important;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .mask {
    width: 300px;
    height: 480px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(24, 121, 240, 0.6);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .line {
    display: none;
  }

  p, button {
    opacity: 1;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  h5 {
    margin-top: 10px;
  }

  p {
    margin: 20px 0 50px;
  }
}

.carouse-img {
  width: 100%;
  height: 640px;
}

.content-one-title {
  text-align: center;
  padding: 130px 0 50px;
  display: flex;
  justify-content: center;
}

.margin-top {
  margin-top: 150px;
}

.content-last {
  position: relative;
}

.content-last-img {
  width: 275px;
  height: 250px;
}

.card-kind {
  padding: 20px 0;
  border: 0 !important;
}

.card-kind:hover {
  h5 {
    color: #30bbfc;
    transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  }
}

.card-deck .card {
  margin-bottom: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Join.vue